import React from "react";
import MessageState from "./message-state";

function AssessmentsUnavailable() {
  return (
    <MessageState
      title="Assessments are Unavailable"
      message="Imagine+ Assessments is currently unavailable, or you do not have access to this product. Check back later."
    />
  );
}

export default AssessmentsUnavailable;
